// ========================
// スライド
// ========================
document.addEventListener('DOMContentLoaded', () => {
    const testRideLpSlideElement = document.querySelector('.js-testRideLpSlide');

    if (!testRideLpSlideElement) {
        return;
    }

    if (typeof Splide === 'undefined') {
        console.error('Splideの読み込みに失敗しています。');
        return;
    }

    const testRideLpSlide = new Splide(testRideLpSlideElement, {
        // ループ
        type: 'loop',

        // 1画面に表示するスライド数
        perPage: 1,

        // 1回の操作で移動するスライド数
        perMove: 1,

        // スライド間の余白
        gap: 0,

        // 自動再生
        autoplay: true,

        // 3秒ごとに切り替え
        interval: 3000,

        // 切り替えに1秒かける
        speed: 1000,

        // ドットを非表示
        pagination: false,

        // 矢印を非表示
        arrows: false,

        // マウスオーバー時も自動再生を止めない
        pauseOnHover: false,

        // フォーカス時も自動再生を止めない
        pauseOnFocus: false,

        // ドラッグ・スワイプ操作を許可
        drag: true,
    });

    testRideLpSlide.mount();
});



// ========================
// スクロール表示
// ========================
document.addEventListener('DOMContentLoaded', () => {
    const fixedCtaElements = document.querySelectorAll('.js-fixedCta');

    if (!fixedCtaElements.length) {
        return;
    }

    let previousScrollY = Math.max(window.scrollY, 0);
    let ticking = false;

    const hideFixedCta = () => {
        fixedCtaElements.forEach((element) => {
            element.classList.add('is-fixedCtaHidden');
            element.classList.remove('is-fixedCtaShow');
        });
    };

    const showFixedCta = () => {
        fixedCtaElements.forEach((element) => {
            element.classList.add('is-fixedCtaShow');
            element.classList.remove('is-fixedCtaHidden');
        });
    };

    const updateFixedCta = () => {
        const currentScrollY = Math.max(window.scrollY, 0);

        if (currentScrollY > previousScrollY) {
            // 下方向へスクロール
            hideFixedCta();
        } else if (currentScrollY < previousScrollY) {
            // 上方向へスクロール
            showFixedCta();
        }

        previousScrollY = currentScrollY;
        ticking = false;
    };

    window.addEventListener(
        'scroll',
        () => {
            if (ticking) {
                return;
            }

            window.requestAnimationFrame(updateFixedCta);
            ticking = true;
        },
        {
            passive: true,
        }
    );
});